module.exports = __webpack_public_path__ + "static/media/derp-interest.7ce0baf6.png";